"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var XhrUpload = /*#__PURE__*/function () {
  function XhrUpload(opts) {
    (0, _classCallCheck2["default"])(this, XhrUpload);
    this.uploads = {};
    this.encoding = opts.encoding;
    this.destination = opts.url;
    this.sendAsBinary = opts.sendAsBinary;
    this.method = opts.method || 'POST';

    if (opts.hasOwnProperty('data')) {
      this.data = opts.data;
    }

    this.useAuthentication = opts.hasOwnProperty('authentication');

    if (this.useAuthentication) {
      this.authentication = opts.authentication;
    }

    this.rawfiles = opts.files.constructor === Array ? opts.files : Array.from(opts.files);
    this.statuses = Array.from(Array(this.rawfiles.length), function (x) {
      return false;
    });
    this.registerEvents();
    this.token = null;
  }

  (0, _createClass2["default"])(XhrUpload, [{
    key: "registerEvents",
    value: function registerEvents() {
      this.progress = null;
      this.started = null;
      this.completed = null;
      this.error = null;
      this.completedAll = null;
      this.response = null;
    }
  }, {
    key: "start",
    value: function start() {
      var _this = this;

      var files = this.rawfiles;
      files.map(function (file, id) {
        return _this.prepareFile(file, id);
      }).forEach(function (file, id) {
        // We're using XHR in order to capture the progress status for an upload,
        // since the Fetch API it is currently lacking [in comparison to XHR] when it comes to request progression.
        var data = _this.sendAsBinary && files && files[0] ? files[0] : _this.encoding !== 'base64' ? _this.createFormData(id, file.file) : _this.createBase64FormData(id, file.file);
        _this.uploads[id] = {
          id: id,
          data: file.file,
          progress: 0
        };
        var XHR = new window.XMLHttpRequest();
        XHR.upload.addEventListener('progress', function (e) {
          return _this.onprogress(e, id);
        });

        XHR.onerror = function (e) {
          return _this.onerror(e, id);
        };

        XHR.onloadstart = function (e) {
          return _this.onstart(e, id);
        };

        XHR.onloadend = function (e) {
          return _this.onend(e, id);
        };

        XHR.onload = function (e) {
          return _this.onload(XHR.response, e, id);
        };

        XHR.open(_this.method, _this.destination);

        if (_this.useAuthentication) {
          XHR.withCredentials = true;
          XHR.setRequestHeader('Authorization', 'Bearer ' + _this.authentication.token);
        }

        XHR.send(data);
      });
    }
  }, {
    key: "createFormData",
    value: function createFormData(id, file) {
      var _this2 = this;

      var formData = new window.FormData();

      if (this.data) {
        if ((0, _typeof2["default"])(this.data) === 'object') {
          Object.keys(this.data).forEach(function (key) {
            if (key !== 'xhr-data') {
              formData.append(key, _this2.data[key]);
            } else {
              console.error("[Upload] Error: 'xhr-data' is a reserved keyword.");
            }
          });
        } else {
          formData.append('xhr-data', this.data);
        }
      }

      formData.append("xhr-upload-".concat(id), file);
      return formData;
    }
  }, {
    key: "createBase64FormData",
    value: function createBase64FormData(id, file) {
      var data = new window.FormData();
      data.append('data', file, 'uploaded-from-file.jpg');
      data.append('encoding', 'base64');
      data.append('fileName', file.name);
      data.append('mimeType', file.type);
      return data;
    }
  }, {
    key: "onstart",
    value: function onstart(e, id) {
      if (typeof this.started === 'function') {
        this.started(id);
      }
    }
  }, {
    key: "onprogress",
    value: function onprogress(e, id) {
      if (e.lengthComputable) {
        this.uploads[id].progress = e.loaded / e.total;

        if (typeof this.progress === 'function') {
          this.progress(e.loaded / e.total, id);
        }
      }
    }
  }, {
    key: "onend",
    value: function onend(e, id) {
      if (typeof this.completed === 'function') {
        this.completed(id);
        this.statuses[id] = true;

        if (this.statuses.every(function (item) {
          return item === true;
        })) {
          if (typeof this.completedAll === 'function') {
            this.completedAll();
          }
        }
      }
    }
  }, {
    key: "onerror",
    value: function onerror(err) {
      if (typeof this.error === 'function') {
        this.error(err);
      }
    }
  }, {
    key: "onload",
    value: function onload(response, event, index) {
      if (typeof this.response === 'function') {
        try {
          var parsedReponse = JSON.parse(response);
          parsedReponse[0].fileIndex = index;
          this.response(parsedReponse);
        } catch (ex) {
          this.response(response, index);
        }
      }
    }
  }, {
    key: "prepareFile",
    value: function prepareFile(file, id) {
      if (this.encoding === 'base64') {
        return {
          file: file
        };
      } else {
        return {
          id: id,
          progress: 0,
          file: file
        };
      }
    }
  }]);
  return XhrUpload;
}();

var _default = XhrUpload;
exports["default"] = _default;